import type { Observable as ObservableType } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-fetch';

export type Response = {
	accountId: string;
	displayName: string;
	key: string;
	name: string;
	avatarUrls: {
		['16x16']: string;
		['24x24']: string;
		['32x32']: string;
		['48x48']: string;
	};
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, accountId: string): ObservableType<Response> =>
	fetchJson$(`${baseUrl}/rest/api/2/user?accountId=${accountId}`);
